import type { RouteRecordRaw } from 'vue-router';

export const usersRoute: RouteRecordRaw = {
  path: '/users',
  name: 'Users',
  component: () => import('./pages/UsersPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:users:list'),
  },
};

export const userDetailRoute: RouteRecordRaw = {
  path: '/users/:id',
  name: 'UserDetail',
  component: () => import('./pages/UserPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:users:get'),
  },
};
